<template>
  <div class="mediation">
    <p>
      <i class="el-icon-s-home"></i>
      <span>网站首页</span>/ 法律事务/ <span>版权调解</span>
    </p>
    <div class="title">
      <!-- <img src="../../assets/icon-12.png" alt="" />
      <span style="text-align: center; margin: 20px 0">版权调解</span> -->
      <h2 style="text-align: center">
        广东省版权保护联合会版权纠纷人民调解委员会简介
      </h2>
      <br />
      <p style="text-indent: 2em">
        广东省版权保护联合会版权纠纷人民调解委员会（原拟用名：广东版权纠纷人民调解委员会）是经广东省版权局批复、广州市司法局同意， 并于2017年5月27日获广州市司法局正式授牌成立。本调解委员会成立以来，充分利用其行业协会的平台作用和版权法律人才以及版权专业人士聚合的优势，积极开展有关知识产权纠纷案件的调解，有效化解当事人双方版权纠纷，维护权利人合法权益和社会安定和谐。
      </p>
      <br />
      <h3 style="color: #409EFF">服务宗旨</h3>
      <p>公平公正  依法调解</p>
      <h3 style="color: #409EFF">联系我们</h3>
      <p>地址：广州市海珠区新港东路1066号国茶荟3-B01</p>
      <p>联系电话：020-37638192</p>
      <h3 style="color: #409EFF">下载表格</h3>
      <a style="text-decoration:underline" href="http://copyright.gzcc315.com/images/版权纠纷调解申请表.docx">版权纠纷调解申请表</a>
      <br>
      <br>
      <img
        width="100%"
        style="display: block; margin: 0 auto"
        src="http://copyright.gzcc315.com/images/501b7be4920c32eb14e2835226f40fa.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.mediation > p {
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  color: gray;
}

.mediation > p i {
  margin-right: 10px;
}

.mediation > p span:hover {
  color: #016fb8;
  cursor: pointer;
}

.mediation .title {
	margin: 20px 0;
	line-height: 30px;
	padding: 20px 30px;
	box-sizing: border-box;
	color: gray;
	font-size: 13px;
}

.mediation .title span {
  font-weight: bold;
  font-size: 18px;
  vertical-align: middle;
}
</style>
